import { render } from "./BigDataPanel.vue?vue&type=template&id=e5086b2e&scoped=true"
import script from "./BigDataPanel.vue?vue&type=script&lang=js"
export * from "./BigDataPanel.vue?vue&type=script&lang=js"

import "./BigDataPanel.vue?vue&type=style&index=0&id=e5086b2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5086b2e"]])

export default __exports__